import React, { ElementType, FC, HTMLAttributes } from 'react';

import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

import PlaySmallIcon from '~/assets/icons/PlaySmallIcon';

interface Sizes {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  ml?: number;
}

interface PlayProps extends Sizes, HTMLAttributes<HTMLElement> {
  component?: ElementType;
  to?: string;
  onClick?: () => void;
  loading?: boolean;
}

interface WrapperProps {
  loading?: boolean;
  disabled?: boolean;
}

const Play: FC<PlayProps> = ({ component, ...rest }) => (
  <Wrapper as={component} {...rest}>
    <StyledPlayIcon />
  </Wrapper>
);

export default Play;

export const hoverScale = ({ disabled }: WrapperProps) => `scale(${disabled ? 1 : 1.2})`;
export const pressScale = ({ disabled }: WrapperProps) => `scale(${disabled ? 1 : 1.1})`;
const Wrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'disabled' &&
    prop !== 'loading' &&
    prop !== 'as' &&
    prop !== 'xs' &&
    prop !== 'sm' &&
    prop !== 'md' &&
    prop !== 'lg' &&
    prop !== 'ml',
})<WrapperProps & Sizes>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ xs = 54 }) => !!xs && xs + 'px'};
  height: ${({ xs = 54 }) => !!xs && xs + 'px'};
  border-radius: 50%;
  background: ${({ theme }) => alpha(theme.palette.common.blueDark, 0.5)};
  transition: 0.3s transform;
  transform: scale(1);
  opacity: ${({ disabled }) => disabled && '0.3'};
  cursor: ${({ loading }) => (loading ? 'wait' : 'pointer')};

  &:hover {
    transform: ${hoverScale};
  }
  &:active {
    transform: ${pressScale};
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${({ sm = 0 }) => !!sm && sm + 'px'};
    height: ${({ sm = 0 }) => !!sm && sm + 'px'};
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: ${({ md = 0 }) => !!md && md + 'px'};
    height: ${({ md = 0 }) => !!md && md + 'px'};
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: ${({ lg = 0 }) => !!lg && lg + 'px'};
    height: ${({ lg = 0 }) => !!lg && lg + 'px'};
  }

  ${({ theme }) => theme.breakpoints.up('ml')} {
    width: ${({ ml = 0 }) => !!ml && ml + 'px'};
    height: ${({ ml = 0 }) => !!ml && ml + 'px'};
  }
`;
const StyledPlayIcon = styled(PlaySmallIcon)`
  width: 100%;
  height: 58%;
  margin-left: 6%;
`;
export const PlayButton = styled(Play)<{ disabled?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1; // z-index must be 1 because it goes right over the Select component
  transform: translate(-50%, -50%) scale(1);

  &:hover {
    transform: translate(-50%, -50%) ${hoverScale};
  }

  &:active {
    transform: translate(-50%, -50%) ${pressScale};
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    transform: translate(-50%, -50%) scale(1);
  }
`;
